import { client } from 'lib/evi-api-gateway';

// ----------------------------------------------------------------------

// Excel 匯入 API（真實 API）
export const importExcelData = (data: any) => {
  console.log(data);
  return client.post_v2({
    url: `${process.env.REACT_APP_API_URL_AI_SERVER}/search-resources`,
    data
  });
  // return response.data;
};

export const importExcelDataQuestion = (data: any) => {
  console.log(data);
  return client.post_v2({
    url: `${process.env.REACT_APP_API_URL_AI_SERVER}/match-indicators-json`,
    data
  });
  // return response.data;
};

// ----------------------------------------------------------------------
